var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddress80 = function SvgAddress80(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Address_80_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Address_80_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 50,
    y: -4,
    width: 45,
    height: 49,
    rx: 2,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 5.5,
    cy: 63.5,
    r: 19.5,
    stroke: "#000",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 23.568,
    y: 28.567,
    width: 48.432,
    height: 59.784,
    rx: 3,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 21,
    width: 48.432,
    height: 59.784,
    rx: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 23.568,
    y: 31.595,
    width: 16.649,
    height: 15.135,
    rx: 1,
    fill: "#A79378"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.865 42.567h6.054M24.324 55.054h27.244M24.324 61.108H41.73",
    stroke: "#A79378",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgAddress80;